var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "diagram-container"
  }, [_c('div', {
    staticClass: "diagram"
  }, [_c('div', {
    staticClass: "chartbar",
    style: {
      left: "".concat(_vm.start, "px"),
      width: "".concat(_vm.stakingDuration, "px"),
      backgroundColor: _vm.darkColor
    }
  }), _c('div', {
    staticClass: "chartbar_complete",
    style: {
      left: "".concat(_vm.start, "px"),
      width: "".concat(_vm.elapsedDuration, "px"),
      backgroundColor: _vm.color
    }
  }), _c('div', {
    staticClass: "now",
    style: {
      left: "".concat(_vm.current, "px"),
      backgroundColor: _vm.color
    }
  })]), _c('div', {
    staticClass: "labels"
  }, [_c('div', [_c('div', {
    staticClass: "diagram_label",
    style: {
      color: _vm.color
    }
  }, [_vm._v(" Start ")]), _c('div', {
    staticClass: "diagram_label",
    style: {
      color: _vm.color
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.startTime * 1000)) + " ")])]), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "diagram_label",
    style: {
      color: _vm.color
    }
  }, [_vm._v(" End ")]), _c('div', {
    staticClass: "diagram_label",
    style: {
      color: _vm.color
    }
  }, [_vm._v(" " + _vm._s(_vm._f("date")(_vm.endTime * 1000)) + " ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }